<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
    import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
    import zhTW from 'ant-design-vue/lib/locale-provider/zh_TW'
    import enUS from 'ant-design-vue/lib/locale-provider/en_US'

    export default {
        name: 'App',
        computed: {
            locale() {
                if (this.$adminLocale === 'zh-Hant') return zhTW
                if (this.$adminLocale === 'en') return enUS
                return zhCN
            }
        }
    }
</script>

<style>
    #app {
        height: 100%;
    }
</style>
